module.exports = __webpack_public_path__ + "img/zhu_zc_xiehaishen.c34d6b47.jpg";